import { reloadGuard } from './reload-guard.js';

/**
 * Watchdog ana-thread tarafı — worker'a 30sn ping atar, reload_required dinler.
 *
 * ⚠️ MİMARİ SINIR (K8): reload main thread'de yürür. Ana thread GERÇEKTEN donduğunda
 * (senkron sonsuz döngü) worker mesajı işlenemez ve location.reload() çalışamaz. Bu
 * watchdog yalnız ana thread'in GEÇİCİ meşgul olduğu (sonra serbest kalan) durumu kurtarır.
 * TAM donma kurtarması OS/kiosk-launcher seviyesinde (RPi: systemd/chromium watchdog) ZORUNLU
 * — deployment runbook'ta belirtilmeli.
 */
let worker: Worker | null = null;
let pingTimer: number | null = null;
let restartCount = 0;

const PING_INTERVAL_MS = 30_000;
const MAX_RESTARTS = 5;

function spawnWorker(): void {
    const w = new Worker(new URL('./watchdog.worker.ts', import.meta.url), {
        type: 'module',
    });
    worker = w;

    w.onmessage = (e: MessageEvent): void => {
        const data = e.data as { type?: string; reason?: string } | undefined;
        if (data?.type === 'reload_required') {
            console.warn('[watchdog] reload required:', data);
            reloadGuard.requestReload('watchdog_' + (data.reason ?? 'timeout'));
        }
    };

    // Worker çökerse (OOM/exception) watchdog sessizce ölmesin — yeniden oluştur (O11).
    const onFailure = (ev: Event | MessageEvent): void => {
        console.error('[watchdog] worker hatası — yeniden başlatılıyor', ev);
        try {
            w.terminate();
        } catch {
            /* noop */
        }
        worker = null;
        if (restartCount < MAX_RESTARTS) {
            restartCount++;
            spawnWorker();
        } else {
            console.error('[watchdog] worker tekrar tekrar çöküyor — yeniden başlatma durduruldu');
        }
    };
    w.onerror = onFailure;
    w.onmessageerror = onFailure;

    // İlk ping hemen
    w.postMessage({ type: 'ping', ts: Date.now() });
}

export function startWatchdog(): void {
    if (worker) return;

    spawnWorker();

    pingTimer = window.setInterval(() => {
        worker?.postMessage({ type: 'ping', ts: Date.now() });
    }, PING_INTERVAL_MS);

    console.info('[watchdog] başlatıldı (30sn ping / 60sn timeout)');
}

export function stopWatchdog(): void {
    if (pingTimer !== null) {
        clearInterval(pingTimer);
        pingTimer = null;
    }
    worker?.postMessage({ type: 'shutdown' });
    worker?.terminate();
    worker = null;
}
